// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._4O3aufTgx{margin-top:31px}._4O3aufTgx>img{display:block}._1qGN64uOx{width:90px;height:90px;-webkit-animation:_1qGN64uOx 3s infinite cubic-bezier(0.165, 0.84, 0.44, 1);animation:_1qGN64uOx 3s infinite cubic-bezier(0.165, 0.84, 0.44, 1);transform-origin:center center}@-webkit-keyframes _1qGN64uOx{0%{transform:rotate(0);opacity:1}20%{transform:rotate(144deg);opacity:0.6}40%{transform:rotate(216deg);opacity:0.8}60%{transform:rotate(360deg);opacity:0.6}80%{transform:rotate(288deg);opacity:0.8}100%{transform:rotate(360deg);opacity:1}}@keyframes _1qGN64uOx{0%{transform:rotate(0);opacity:1}20%{transform:rotate(144deg);opacity:0.6}40%{transform:rotate(216deg);opacity:0.8}60%{transform:rotate(360deg);opacity:0.6}80%{transform:rotate(288deg);opacity:0.8}100%{transform:rotate(360deg);opacity:1}}._4AMsFMVtx{margin-top:-90px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"spinner": "_4O3aufTgx",
	"circle": "_1qGN64uOx",
	"cloud": "_4AMsFMVtx"
};
module.exports = exports;
